import httpCustomer from "./httpServiceCustomer";

const apiEndpoint = "/senhasP";

export function getSenhas() {
    return httpCustomer.get(apiEndpoint);
}
